import gql from 'graphql-tag';

const createVinBlacklistMutation = gql`
  mutation createVinBlacklist($input: CreateVinBlacklistInput!) {
    createVinBlacklist(input: $input) {
      success
      errors
    }
  }
`;

export default createVinBlacklistMutation;
